import { useAuthStore } from '@/stores/authstore';
import { showSessionExpiredModalComp } from '@/stores/modalstore';

let inactivityTimer;
const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];

/**
 * Función que se ejecuta cuando el temporizador de inactividad expira.
 * Cierra la sesión solo si es un usuario logueado (no invitado).
 */
function handleInactivity() {
  console.warn("Inactividad detectada. Mostrando modal de expiración...");
  const authStore = useAuthStore();
  // Mostramos el modal y le pasamos la lógica de logout como un callback.
  showSessionExpiredModalComp(() => {
    const logoutUrl = authStore.logout();
    if (logoutUrl) {
      window.location.href = logoutUrl;
    } else {
      window.location.reload();
    }
  });
}

/**
 * Reinicia el temporizador de inactividad.
 */
export function resetTimer() {
  clearTimeout(inactivityTimer);
  const timeoutMinutes = parseInt(process.env.VUE_APP_HEARTBEAT_TIME_MINUTES, 10);

  if (!isNaN(timeoutMinutes) && timeoutMinutes > 0) {
    const timeoutMilliseconds = timeoutMinutes * 60 * 1000;
    inactivityTimer = setTimeout(handleInactivity, timeoutMilliseconds);
  }
}

/**
 * Inicializa los listeners para detectar actividad del usuario.
 */
export function initializeHeartbeat() {
  activityEvents.forEach(event => window.addEventListener(event, resetTimer, true));
  resetTimer(); // Inicia el temporizador por primera vez.
}

/**
 * Limpia los listeners y el temporizador para evitar fugas de memoria.
 */
export function cleanupHeartbeat() {
    activityEvents.forEach(event => window.removeEventListener(event, resetTimer, true));
    clearTimeout(inactivityTimer);
}